<template>
  <out-layout>
    <div slot="form-content" class="message">
      <v-card-text class="content">
        <v-layout
          justify-center
          align-center
          row
        >
          <v-flex>
            <img
              class="mr-4 icon"
              src="/src/assets/image/icon/verified.svg"
              alt="Ícone de Conta Verificada"
            >
          </v-flex>

          <v-flex>
            <h3 class="title">Agora sua conta está ativa</h3>
            <span class="text">
              Clique no link abaixo e insira seus dados de acesso do Portal Ambiental.
            </span>
          </v-flex>
        </v-layout>
      </v-card-text>
    </div>

    <template slot="navigation">
      <v-btn flat small color="primary" class="link" :to="'/requerente/conta/entrar'">
        <v-icon left>mdi-account-circle</v-icon>
        <span class="text">Voltar ao login</span>
      </v-btn>
    </template>
  </out-layout>
</template>

<script>
import OutLayout from '@/layouts/OutLayout';
import UserService from '@/services/UserService';

export default {
  name: 'ActivationSignup',
  components: {
    OutLayout,
  },
  created() {
    this.$store.dispatch('setLoadingDialog', true);
    UserService
      .activate(this.$route.params.confirmation_token)
      // .then(() => {
      //   console.log(resp);
      // })
      .catch((responseError) => {
        this.$swal({
          type: 'error',
          title: 'Erro',
          html: responseError.response.data.join('<br/>'),
        });
        this.$router.push('/requerente/conta/entrar');
      })
      .finally(() => {
        this.$store.dispatch('setLoadingDialog', false);
      });
  },
};
</script>

<style scoped lang="scss">
.message {
  .content {
    & {
      padding: 0;
      margin-top: 2rem;
      margin-bottom: 2rem;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
    }
    .icon {
      width: 80px;
    }
  }
}

.navigation {
  > .link {
    text-transform: none;
  }
}
</style>
